import axios from "axios";

async function ImageGenerator(prompt) {
  const input = {
    prompt: prompt,
    aspect_ratio: "1:1",
    output_format: "webp",
    output_quality: 80,
    safety_tolerance: 2,
    prompt_upsampling: true,
  };

  try {
    console.log("Sending request to server:", input);
    const apiUrl =
      process.env.NODE_ENV === "production"
        ? "https://www.culturalcuisine.xyz/api"
        : "http://localhost:5001/api";
    console.log("API URL: ", apiUrl);

    const axiosInstance = axios.create({
      baseURL: apiUrl,
      timeout: 240000,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const response = await axiosInstance.post("/generate-image", input);
    console.log("Server response:", response.data);

    if (!response.data || !response.data.imageUrl) {
      throw new Error("No valid image URL received from server");
    }
    if (
      typeof response.data.imageUrl !== "string" ||
      !response.data.imageUrl.startsWith("http")
    ) {
      throw new Error("Invalid image URL received from server");
    }
    console.log("Received image URL from server:", response.data.imageUrl);
    return response.data.imageUrl;
  } catch (error) {
    console.error("Error generating image:", error);
    if (error.response && error.response.data) {
      throw new Error(`Server error: ${JSON.stringify(error.response.data)}`);
    } else if (error.request) {
      throw new Error("No response received from server");
    } else {
      throw new Error(`Error: ${error.message}`);
    }
  }
}

export default ImageGenerator;
